/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum LeadTableType {
    ALL = 'All',
    INTAKE = 'Intake',
    ACTIVE_CLIENT = 'ActiveClient',
    REVIEW = 'Review',
    ARCHIVE = 'Archive',
    REFERRAL = 'Referral',
    SHARED_ATTORNEY = 'SharedAttorney',
}
